import type {
  IExtractedResultModel,
  IExtractedResultViewModel,
  IExtractedItemViewModel,
  IExtractedItemResponse,
  IExtractedNodeReponse,
  IExtractedNodeViewModel,
  IProcessItemModel,
  IProcessItemViewModel,
  IProcessInfoModel,
  IProcessInfoViewModel,
  UserInstructionResponse,
  UserInstructionViewModel,
} from "@models/extraction";

export const buildExtractedItemViewModel = (
  field: IExtractedItemResponse,
): IExtractedItemViewModel => ({
  id: field.id,
  key: field.key,
  value: field.value,
  page: field.page,
  originalPage: field.original_page ?? 0,
  uom: field.uom,
  bbox: field.bbox,
  conf: field.conf,
});

const buildExtractedNodeViewModel = (
  response: IExtractedNodeReponse,
): IExtractedNodeViewModel => ({
  id: response.id,
  displayName: response.display_name,
  level: response.level,
  isExpandable: response.is_expandable,
  children: response.children.map(buildExtractedNodeViewModel),
  data: response.data ? buildExtractedItemViewModel(response.data) : null,
});

export const buildExtractedResultViewModel = (
  response: IExtractedResultModel,
): IExtractedResultViewModel => {
  const isPdf = response.is_pdf ?? false;
  const noPages = response.no_pages ?? 1;

  return {
    displayNode: response.display_nodes.map(buildExtractedNodeViewModel),
    previewUrl: response.preview_url,
    isPdf,
    noPages,
  };
};

export const buildProcessItemViewModel = (
  item: IProcessItemModel,
): IProcessItemViewModel => ({
  id: item.id,
  fileName: item.file_name,
  status: item.status,
  demoImage: item.demo_image,
  createdAt: item.created_at,
  errorMessage: item.error_message,
});

export const buildProcessedInfoViewModel = (
  response: IProcessInfoModel,
): IProcessInfoViewModel => ({
  id: response.id,
  status: response.status,
  createdAt: response.created_at,
  isBatch: response.is_batch,
  errorMessage: response.error_message,
  items: response.items.map(buildProcessItemViewModel),
  mappingEnabled: response.mapping_enabled ?? false,
  doctypeCode: response.doctype_code ?? null,
});

export const buildUserInstructionViewModel = (
  response: UserInstructionResponse,
): UserInstructionViewModel => ({
  id: response.id,
  name: response.name,
  instruction: response.instruction,
  doctypeCode: response.doctype_code,
  createdBy: response.created_by,
});
